'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
}); // errors are returned a little weird from the validator so we split it out

exports.default = function () {
  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var name = arguments[1];
  return errors[name] && typeof errors[name] !== 'string' ? errors[name][0] : errors[name] || '';
};